const SELECTOR = "h1, h2, h3, h4, h5, h6";

/**
 * Apply soft-hyphens to all heading elements in the document using the German
 * hyphenation pattern. The pattern module is loaded lazily so pages without
 * headings do not pay the download cost.
 * @returns {Promise<void>}
 */
async function hyphenateHeadings() {
	const headings = document.querySelectorAll(SELECTOR);
	if (headings.length === 0) return;

	const { default: hyphen } = await import("./lib/hyphen-de.mjs");

	for (const heading of headings) {
		heading.innerHTML = hyphen.hyphenateHTMLSync(heading.innerHTML);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", hyphenateHeadings);
} else {
	hyphenateHeadings();
}
